import React from 'react';

class Controls extends React.Component {
    render() {
        return (
            <div className="controls">
                <button className="back" onClick={this.props.back} disabled={this.props.step === 0}>Back</button>
                {this.props.step < 1 ?
                    <button className="next" onClick={this.props.next} disabled={!this.props.valid}>Next</button>
                :
                    <button className="submit" onClick={this.props.handleSubmit} disabled={!this.props.valid}>
                        <img src={require("../images/tick.svg")} alt="Tick" />
                        Submit
                    </button>
                }
            </div>
        )
    }
}

export default Controls;